import { Target } from '../@types';

const targetsForAdmins: Target[] = [
  { value: 'email', type: 'text', isAPI: false },
  { value: 'firstName', type: 'text', isAPI: false },
  { value: 'lastName', type: 'text', isAPI: false },
];

export default targetsForAdmins;
